const cyrillicToLatinMap: Record<string, string> = {
    А: 'A',
    В: 'B',
    Е: 'E',
    К: 'K',
    М: 'M',
    Н: 'H',
    О: 'O',
    Р: 'P',
    С: 'C',
    Т: 'T',
    У: 'Y',
    Х: 'X',
}

const latinToCyrillicMap: Record<string, string> = Object.fromEntries(
    Object.entries(cyrillicToLatinMap).map(([cyr, lat]) => [lat, cyr])
)

export type TransliterationDirection = 'cyrillic-to-latin' | 'latin-to-cyrillic'

export function transliterateCarNumber(
    value: string,
    direction: TransliterationDirection = 'cyrillic-to-latin'
): string {
    const map = direction === 'cyrillic-to-latin' ? cyrillicToLatinMap : latinToCyrillicMap

    return value
        .split('')
        .map((ch) => map[ch] || ch)
        .join('')
}
